var map = {
	"./ItGoals/1.svg": 379,
	"./ItGoals/2.svg": 380,
	"./ItGoals/3.svg": 381,
	"./ItGoals/4.svg": 382,
	"./ItGoals/courses/ai.png": 534,
	"./ItGoals/courses/computer_literacy.png": 535,
	"./ItGoals/courses/frontend.png": 536,
	"./ItGoals/courses/game_design.png": 537,
	"./ItGoals/courses/gamedev.png": 538,
	"./ItGoals/courses/graphic_design.png": 539,
	"./ItGoals/courses/main.png": 540,
	"./ItGoals/courses/predprinimatelstvo.png": 541,
	"./ItGoals/courses/programming_basics.png": 542,
	"./ItGoals/courses/python.png": 543,
	"./ItGoals/courses/scratch.png": 544,
	"./ItGoals/courses/unity.png": 545,
	"./ItGoals/courses/video_content.png": 546,
	"./ItGoals/courses/videoblogging.png": 547,
	"./ItGoals/courses/web-razrabotka.png": 548,
	"./ItGoals/courses/webdev.png": 549,
	"./ItGoals/coursesNew/ai.png": 428,
	"./ItGoals/coursesNew/computer_literacy.png": 429,
	"./ItGoals/coursesNew/ege-informatika-desk.png": 355,
	"./ItGoals/coursesNew/ege-informatika.png": 356,
	"./ItGoals/coursesNew/frontend.png": 430,
	"./ItGoals/coursesNew/game_design.png": 431,
	"./ItGoals/coursesNew/graphic_design.png": 432,
	"./ItGoals/coursesNew/math-desk.png": 357,
	"./ItGoals/coursesNew/math.png": 358,
	"./ItGoals/coursesNew/predprinimatelstvo.png": 433,
	"./ItGoals/coursesNew/programming_basics.png": 434,
	"./ItGoals/coursesNew/python.png": 435,
	"./ItGoals/coursesNew/scratch.png": 436,
	"./ItGoals/coursesNew/unity.png": 437,
	"./ItGoals/coursesNew/videoblogging.png": 438,
	"./ItGoals/coursesNew/web-razrabotka.png": 439,
	"./ItGoals/cube.svg": 550,
	"./ItGoals/cursor1.svg": 350,
	"./ItGoals/cursor2.svg": 351,
	"./ItGoals/cursor3.svg": 352,
	"./ItGoals/cursor4.svg": 353,
	"./ItGoals/enter.svg": 551,
	"./ItGoals/globe.svg": 552,
	"./ItGoals/outbreak.svg": 553,
	"./ItGoals/puzzle.svg": 554,
	"./ItGoals/story1.png": 555,
	"./ItGoals/story2.png": 556,
	"./ItGoals/story3.png": 557,
	"./PlatformExample/PlatformLogo1.svg": 486,
	"./PlatformExample/PlatformLogo2.svg": 487,
	"./PlatformExample/PlatformLogo3.svg": 488,
	"./PlatformExample/PlatformLogo4.svg": 489,
	"./SK-base.svg": 795,
	"./SK-dark.svg": 796,
	"./achieve-yellow-big.svg": 530,
	"./achieve-yellow-small.svg": 532,
	"./alfa.svg": 797,
	"./application-form-background-mobile.png": 526,
	"./application-form-background.png": 525,
	"./arrowButton.svg": 347,
	"./arrowRight.svg": 682,
	"./components/footer/tg.svg": 484,
	"./components/footer/vk.svg": 482,
	"./components/footer/wa.svg": 483,
	"./components/header/tg.svg": 363,
	"./components/header/vk.svg": 361,
	"./components/header/wa.svg": 362,
	"./cross.svg": 527,
	"./cursor-desk.svg": 531,
	"./cursor-mobile.svg": 533,
	"./detail/ai/6.1.png": 604,
	"./detail/ai/6.2.png": 605,
	"./detail/ai/6.3.png": 606,
	"./detail/ai/6.svg": 459,
	"./detail/ai/7.svg": 443,
	"./detail/ai/line.3.svg": 607,
	"./detail/ai/line.svg": 364,
	"./detail/ai/logoPage.png": 413,
	"./detail/ai/logoPagePhone.png": 398,
	"./detail/ai/spanBorder.svg": 384,
	"./detail/arrow.svg": 441,
	"./detail/computernaya-gramotnost/6.1.png": 608,
	"./detail/computernaya-gramotnost/6.2.png": 609,
	"./detail/computernaya-gramotnost/6.3.png": 610,
	"./detail/computernaya-gramotnost/6.svg": 460,
	"./detail/computernaya-gramotnost/7.svg": 444,
	"./detail/computernaya-gramotnost/line.3.svg": 611,
	"./detail/computernaya-gramotnost/line.svg": 365,
	"./detail/computernaya-gramotnost/logoPage.png": 414,
	"./detail/computernaya-gramotnost/logoPagePhone.png": 399,
	"./detail/computernaya-gramotnost/spanBorder.svg": 385,
	"./detail/ege-informatika/6.1.png": 612,
	"./detail/ege-informatika/6.2.png": 613,
	"./detail/ege-informatika/6.3.png": 614,
	"./detail/ege-informatika/6.svg": 461,
	"./detail/ege-informatika/7.svg": 445,
	"./detail/ege-informatika/line.3.svg": 615,
	"./detail/ege-informatika/line.svg": 366,
	"./detail/ege-informatika/logoPage.png": 415,
	"./detail/ege-informatika/logoPagePhone.png": 400,
	"./detail/ege-informatika/spanBorder.svg": 354,
	"./detail/frontend/6.1.png": 616,
	"./detail/frontend/6.2.png": 617,
	"./detail/frontend/6.3.png": 618,
	"./detail/frontend/6.svg": 462,
	"./detail/frontend/7.svg": 446,
	"./detail/frontend/line.3.svg": 619,
	"./detail/frontend/line.svg": 367,
	"./detail/frontend/logoPage.png": 416,
	"./detail/frontend/logoPagePhone.png": 401,
	"./detail/frontend/spanBorder.svg": 386,
	"./detail/game-design/6.1.png": 620,
	"./detail/game-design/6.2.png": 621,
	"./detail/game-design/6.3.png": 622,
	"./detail/game-design/6.svg": 463,
	"./detail/game-design/7.svg": 447,
	"./detail/game-design/line.3.svg": 623,
	"./detail/game-design/line.svg": 368,
	"./detail/game-design/logoPage.png": 417,
	"./detail/game-design/logoPagePhone.png": 402,
	"./detail/game-design/spanBorder.svg": 387,
	"./detail/graphic-design-pro/6.1.png": 624,
	"./detail/graphic-design-pro/6.2.png": 625,
	"./detail/graphic-design-pro/6.3.png": 626,
	"./detail/graphic-design-pro/6.svg": 464,
	"./detail/graphic-design-pro/7.svg": 448,
	"./detail/graphic-design-pro/line.3.svg": 627,
	"./detail/graphic-design-pro/line.svg": 369,
	"./detail/graphic-design-pro/logoPage.png": 418,
	"./detail/graphic-design-pro/logoPagePhone.png": 403,
	"./detail/graphic-design-pro/spanBorder.svg": 388,
	"./detail/graphic-design/6.1.png": 628,
	"./detail/graphic-design/6.2.png": 629,
	"./detail/graphic-design/6.3.png": 630,
	"./detail/graphic-design/6.svg": 465,
	"./detail/graphic-design/7.svg": 449,
	"./detail/graphic-design/line.3.svg": 631,
	"./detail/graphic-design/line.svg": 370,
	"./detail/graphic-design/logoPage.png": 419,
	"./detail/graphic-design/logoPagePhone.png": 404,
	"./detail/graphic-design/spanBorder.svg": 389,
	"./detail/greenieLike.svg": 632,
	"./detail/intensive/6.1.png": 633,
	"./detail/intensive/6.2.png": 634,
	"./detail/intensive/6.3.png": 635,
	"./detail/intensive/6.svg": 466,
	"./detail/intensive/7.svg": 450,
	"./detail/intensive/line.3.svg": 636,
	"./detail/intensive/line.svg": 371,
	"./detail/intensive/logoPage.png": 420,
	"./detail/intensive/logoPagePhone.png": 405,
	"./detail/intensive/spanBorder.svg": 390,
	"./detail/line-mobile.svg": 442,
	"./detail/line.3.svg": 474,
	"./detail/line.svg": 440,
	"./detail/orangeLight.svg": 637,
	"./detail/osnovy-programmirovaniya/6.1.png": 638,
	"./detail/osnovy-programmirovaniya/6.2.png": 639,
	"./detail/osnovy-programmirovaniya/6.3.png": 640,
	"./detail/osnovy-programmirovaniya/6.svg": 467,
	"./detail/osnovy-programmirovaniya/7.svg": 451,
	"./detail/osnovy-programmirovaniya/line.3.svg": 641,
	"./detail/osnovy-programmirovaniya/line.svg": 372,
	"./detail/osnovy-programmirovaniya/logoPage.png": 421,
	"./detail/osnovy-programmirovaniya/logoPagePhone.png": 406,
	"./detail/osnovy-programmirovaniya/spanBorder.svg": 391,
	"./detail/predprinimatelstvo/6.1.png": 642,
	"./detail/predprinimatelstvo/6.2.png": 643,
	"./detail/predprinimatelstvo/6.3.png": 644,
	"./detail/predprinimatelstvo/6.svg": 468,
	"./detail/predprinimatelstvo/7.svg": 452,
	"./detail/predprinimatelstvo/line.3.svg": 645,
	"./detail/predprinimatelstvo/line.svg": 373,
	"./detail/predprinimatelstvo/logoPage.png": 422,
	"./detail/predprinimatelstvo/logoPagePhone.png": 407,
	"./detail/predprinimatelstvo/spanBorder.svg": 392,
	"./detail/purpleHeart.svg": 646,
	"./detail/python/6.1.png": 647,
	"./detail/python/6.2.png": 648,
	"./detail/python/6.3.png": 649,
	"./detail/python/6.svg": 469,
	"./detail/python/7.svg": 453,
	"./detail/python/line.3.svg": 650,
	"./detail/python/line.svg": 374,
	"./detail/python/logoPage.png": 423,
	"./detail/python/logoPagePhone.png": 408,
	"./detail/python/spanBorder.svg": 393,
	"./detail/scratch/6.1.png": 651,
	"./detail/scratch/6.2.png": 652,
	"./detail/scratch/6.3.png": 653,
	"./detail/scratch/6.svg": 470,
	"./detail/scratch/7.svg": 454,
	"./detail/scratch/line.3.svg": 654,
	"./detail/scratch/line.svg": 375,
	"./detail/scratch/logoPage.png": 424,
	"./detail/scratch/logoPagePhone.png": 409,
	"./detail/scratch/spanBorder.svg": 394,
	"./detail/unity/6.1.png": 655,
	"./detail/unity/6.2.png": 656,
	"./detail/unity/6.3.png": 657,
	"./detail/unity/6.svg": 471,
	"./detail/unity/7.svg": 455,
	"./detail/unity/line.3.svg": 658,
	"./detail/unity/line.svg": 376,
	"./detail/unity/logoPage.png": 425,
	"./detail/unity/logoPagePhone.png": 410,
	"./detail/unity/spanBorder.svg": 395,
	"./detail/videoblogging/6.1.png": 659,
	"./detail/videoblogging/6.2.png": 660,
	"./detail/videoblogging/6.3.png": 661,
	"./detail/videoblogging/6.svg": 472,
	"./detail/videoblogging/7.svg": 456,
	"./detail/videoblogging/line.3.svg": 662,
	"./detail/videoblogging/line.svg": 377,
	"./detail/videoblogging/logoPage.png": 426,
	"./detail/videoblogging/logoPagePhone.png": 411,
	"./detail/videoblogging/spanBorder.svg": 396,
	"./detail/web-razrabotka/6.1.png": 663,
	"./detail/web-razrabotka/6.2.png": 664,
	"./detail/web-razrabotka/6.3.png": 665,
	"./detail/web-razrabotka/6.svg": 473,
	"./detail/web-razrabotka/7.svg": 457,
	"./detail/web-razrabotka/line.3.svg": 666,
	"./detail/web-razrabotka/line.svg": 378,
	"./detail/web-razrabotka/logoPage.png": 427,
	"./detail/web-razrabotka/logoPagePhone.png": 412,
	"./detail/web-razrabotka/spanBorder.svg": 397,
	"./detail/yellowPalms.svg": 667,
	"./egeChildren.png": 524,
	"./firstSteps/1.png": 521,
	"./firstSteps/2.png": 522,
	"./firstSteps/3.png": 523,
	"./firstSteps1.png": 798,
	"./firstSteps2.png": 520,
	"./fotoTestimonialsCustomers.png": 799,
	"./gift1.svg": 499,
	"./gift2.svg": 500,
	"./globe-svg.svg": 383,
	"./globe.png": 800,
	"./green-thumb.png": 567,
	"./greenieLike.svg": 801,
	"./holiday1.svg": 501,
	"./holiday2.svg": 502,
	"./holiday3.svg": 503,
	"./holiday4.svg": 504,
	"./learning/learnGif1.gif": 561,
	"./learning/learnGif2.gif": 562,
	"./learning/learnGif3.gif": 563,
	"./learning/learnGif4.gif": 564,
	"./li/Blue.svg": 571,
	"./li/Green.svg": 572,
	"./li/LightCyan.svg": 573,
	"./li/Lime.svg": 574,
	"./li/NadeshikoPink.svg": 575,
	"./li/Pink.svg": 576,
	"./li/Purple.svg": 577,
	"./li/Sky.svg": 578,
	"./li/SpanishPink.svg": 579,
	"./li/Yellow.svg": 580,
	"./logoAlg.svg": 490,
	"./logoFix.svg": 518,
	"./logoFooter.svg": 528,
	"./logoFooterMobile.svg": 529,
	"./logoHeader.svg": 491,
	"./logoHeaderPc.svg": 492,
	"./logoNavPopUp.svg": 493,
	"./menuNav.svg": 802,
	"./ok.svg": 349,
	"./orangeLight.svg": 803,
	"./ozon.png": 804,
	"./phone.svg": 519,
	"./placeholder.png": 569,
	"./professor/professor1.png": 805,
	"./professor/professor2.png": 806,
	"./professor/professor3.png": 807,
	"./professor/professor4.png": 808,
	"./professor/professor5.png": 809,
	"./professor/professor6.jpg": 810,
	"./purpleHeart.svg": 811,
	"./red-fire.png": 566,
	"./rf.svg": 812,
	"./room/room1.jpg": 813,
	"./room/room2.jpg": 814,
	"./room/room3.jpg": 815,
	"./room/room4.jpg": 816,
	"./sk.svg": 817,
	"./skY.png": 818,
	"./star.svg": 507,
	"./stars.svg": 570,
	"./subtract.svg": 819,
	"./subtract2.svg": 820,
	"./tick.svg": 701,
	"./triangularRight.svg": 884,
	"./violet-heart.png": 565,
	"./yandex.png": 821,
	"./yellow-hello.png": 568,
	"./yellow-line-1-desc.svg": 558,
	"./yellow-line-2-desc.svg": 559,
	"./yellow-line-slider.svg": 560,
	"./yellowPalms.svg": 822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 794;